import React from 'react';
import { useTranslation } from 'react-i18next';

import type { CampaignStage } from '@/services/ws-digital/src/main/resources/rest-api';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Filter } from '@/js/libs/ui/src/V2';

import { useTranslateOptionLabel } from 'src/hooks/useTranslateOptionLabel';
import type { Option } from 'src/types';
import { useStagesOptions } from '../hooks/useStagesOptions';

interface StagesFilterProps {
  value: Option<CampaignStage>[] | null;
  onChange: (value: Option<CampaignStage>[]) => void;
  label?: string;
}

export const StagesFilter: React.FC<StagesFilterProps> = React.memo(function StagesFilter({ value, onChange, label }) {
  const [t] = useTranslation(['backend', 'common']);
  const { options, pending: loading } = useStagesOptions();
  const translateOptionLabel = useTranslateOptionLabel(t, 'common');

  const handleChange = useCallbackRef((newValue: Option<CampaignStage>[]) => {
    onChange(newValue);
  });

  return (
    <Filter<CampaignStage>
      label={label || t('common:STAGES')}
      loading={loading}
      selected={value ?? []}
      onChange={handleChange}
      options={options}
      isMulti
      dataTestId='stages-dropdown'
      formatOptionLabel={translateOptionLabel}
    />
  );
});
